<app-stepper [step]="step"></app-stepper>
<div>
  <div class="payment-container">
    <div #hook id="dropin" class="payment"></div>
  </div>

  <div class="mat-error" *ngIf="hasError">
    <span>{{'error.unknown' | translate}}</span>
  </div>
</div>


